import Vue from 'vue'
import Router from 'vue-router'
import { util } from '@/utils/utils.js'
import sys from './sys/sys'
Vue.use(Router)
const titleMap={
    "/project/form/query/ims_corp_pj":"参建方评价",
    "/project/form/query/t_inspect_record":"问题缺陷",
}
const router = new Router({
    routes: [
        {
            path: '/form',
            component: resolve => require(['@/views/index.vue'], resolve),
            children: [
                ...sys
            ]
        },
        // 项目大屏
        {
            path: '/projLargeIndex',
            component: resolve => require(['@/components/largeScreen/projectGather/index.vue'], resolve),
            children: [
                {
                    path: 'projLargeScreen',
                    name: 'projLargeScreen',
                    meta: {
                        title: '项目大屏'
                    },
                    component: resolve => require(['@/components/largeScreen/project/project.vue'], resolve)
                },
                {
                    path: 'distribution',
                    name: 'distribution',
                    meta: {
                        title: '项目看板'
                    },
                    component: resolve => require(['@/components/largeScreen/projectGather/projectGather.vue'], resolve)

                },
            ]
        },
        //首页
        {
            path: '/index',
            name: 'index',
            meta: {
                title: '项目'
            },
            component: resolve => require(['@/views/index.vue'], resolve),
            children: [
                {
                    path: 'project',
                    meta: {
                        title: '项目'
                    },
                    component: resolve => require(['@/views/project/index.vue'], resolve),
                },
                {
                    path: 'largeScreen',
                    meta: {
                        title: '集团大屏'
                    },
                    component: resolve => require(['@/components/largeScreen/home/home.vue'], resolve)
                },
                {
                    path: 'largeScreen_zgd',
                    meta: {
                        title: '项目全景-自购地'
                    },
                    component: resolve => require(['@/components/largeScreen/home/home_zgd.vue'], resolve)
                },
                {
                    path: 'largeScreen_zl',
                    meta: {
                        title: '项目全景-租赁'
                    },
                    component: resolve => require(['@/components/largeScreen/home/home_zl.vue'], resolve)
                },
                {
                    path: 'report',
                    meta: {
                        title: '集团报表'
                    },
                    component: resolve => require(['@/components/largeScreen/report/report.vue'], resolve)
                },
                {
                    path: 'documentManage',
                    meta: {
                        title: '文档模板管理'
                    },
                    component: resolve => require(['@/components/document-manage/index.vue'], resolve),
                },
                {
                    path: 'test',
                    meta: {
                        title: '测试接口'
                    },
                    component: resolve => require(['@/views/test.vue'], resolve),
                },
                {
                    path: 'form/query/:formKey',
                    name: 'form-query',
                    meta: {
                        // title: '计划模板管理'
                    },
                    component: () => import('@/common/form/form-view/form-view.vue')
                },
                {
                    path: 'menuManage',
                    meta: {
                        title: '菜单管理'
                    },
                    component: resolve => require(['@/components/sys/menuManage.vue'], resolve),
                },
                {
                    path: 'roleAuth',
                    meta: {
                        title: '角色授权'
                    },
                    component: resolve => require(['@/components/sys/roleAuth.vue'], resolve),
                },
                {
                    path: 'dataDictionary',
                    meta: {
                        title: '数据字典'
                    },
                    component: resolve => require(['@/components/proj/dataDictionary.vue'], resolve),
                },
                {
                    path: 'enterprisesSet',
                    meta: {
                        title: '组织架构'
                    },
                    component: resolve => require(['@/components/administration/enterprisesSet.vue'], resolve),
                },
                {
                    path: 'library',
                    component: resolve => require(['@/components/library/index-library.vue'], resolve),
                    children: [
                        {
                            path: '',
                            meta: {
                                title: '检查项设置'
                            },
                            component: resolve => require(['@/components/library/checkSet.vue'], resolve)
                        },
                        {
                            path: 'form/query/:formKey',
                            name: 'form-query',
                            meta: {
                               title: '表单查询'
                            },
                            component: () => import('@/common/form/form-view/form-view.vue')
                        },
                        {
                            path: 'checkSets',
                            name: 'checkSets',
                            meta: {
                                title: '检查项设置'
                            },
                            component: resolve => require(['@/components/library/checkSet2.vue'], resolve)
                        },

                    ]
                },
                {
                    path: 'projectForm',
                    component: resolve => require(['@/views/project-form/index.vue'], resolve),
                    children: [
                        {
                            path: 'query/:formKey',
                            name: 'form-query',
                            meta: {
                               title: '项目全景表单'
                            },
                            component: () => import('@/common/form/form-view/form-view.vue')
                        },

                    ]
                },
                {
                    path: 'basic-data',
                    meta: {
                        title: '基础数据'
                    },
                    component: resolve => require(['@/views/basic-data/home.vue'], resolve),
                    children: [
                        {
                            path: 'query/:formKey',
                            name: 'form-query',
                            meta: {
                               title: '表单查询'
                            },
                            component: () => import('@/common/form/form-view/form-view.vue')
                        },
                        {
                            path: 'wf/approval-list',
                            name: 'wf/approval-list',
                            meta: {
                              title: '我的待办'
                            },
                            component: resolve => require(['@/sys/wf/approval/approval-list/index.vue'], resolve)
                        },
                        {
                            path: 'wf/apply-list',
                            name: 'wf/apply-list',
                            meta: {
                              title: '我的申请'
                            },
                            component: resolve => require(['@/sys/wf/apply/apply-list/index.vue'], resolve)
                        },
                        {
                            path: 'wf/copy-list',
                            name: 'wf/copy-list',
                            meta: {
                              title: '抄送给我'
                            },
                            component: resolve => require(['@/sys/wf/copy/copy-list/index.vue'], resolve)
                        },
                        {
                            path: 'wf/approval-finish-list',
                            name: 'wf/approval-finish-list',
                            meta: {
                              title: '我的已办'
                            },
                            component: resolve => require(['@/sys/wf/approval/approval-finish-list/index.vue'], resolve)
                        },
                        {
                            path: 'wf/manage',
                            name: 'wf/manage',
                            meta: {
                              title: '流程管理'
                            },
                            component: resolve => require(['@/sys/wf/manage/workflow-manage.vue'], resolve)
                        },
                        {
                            path: 'menu',
                            name: 'menu',
                            meta: {
                              title: '菜单管理'
                            },
                            component: resolve => require(['@/sys/menu/index.vue'], resolve)
                        },

                    ]
                },
                {
                    path: '*',
                    redirect: '/proj',
                },
            ]
        },
      {
        path: '/mytask',
        name: 'mytask',
        meta: {
          title: '上报1'
        },
        component: resolve => require(['@/components/progress/AddProject.vue'], resolve)
      },
        //项目首页
   	    {

            path: '/project',
            component: resolve => require(['@/views/project-index.vue'], resolve),
            children: [
                {
                    path: 'overview',
                    meta: {
                        title: '工程概况'
                    },
                    component: resolve => require(['@/components/projProfile/index.vue'], resolve),
                    children: [
                        {
                            path: 'form/query/:formKey',
                            name: 'form-query',
                            meta: {
                            // title: '表单查询'
                            },
                            component: () => import('@/common/form/form-view/form-view.vue')
                        },
                        {
                            path: 'news',
                            name: 'news',
                            meta: {
                                title: '新闻公告'
                            },
                            component: resolve => require(['@/components/projProfile/news.vue'], resolve)
                        },

                    ]
                },
                {
                    path: 'projReport',
                    name: 'projReport',
                    meta: {
                        title: '项目汇报'
                    },
                    component: resolve => require(['@/components/projProfile/projReport.vue'], resolve)
                },
                {
                    path: 'projArea',
                    name: 'projArea',
                    meta: {
                        title: '图纸管理'
                    },
                    component: resolve => require(['@/components/projProfile/proj-area.vue'], resolve)
                },
                {
                    path: 'projMeeting',
                    meta: {
                        title: '项目会议'
                    },
                    component: resolve => require(['@/components/proj-meeting/index.vue'], resolve),
                    children: [
                        {
                            path: 'form/query/:formKey',
                            name: 'form-query',
                            meta: {
                                title: '项目会议'
                            },
                            component: () => import('@/common/form/form-view/form-view.vue')
                        },
                    ]
                },
                {
                    path: 'workContactBill',
                    meta: {
                        title: '工作联系单'
                    },
                    component: resolve => require(['@/components/work-contact/index.vue'], resolve),
                    children: [
                        {
                            path: 'form/query/:formKey',
                            name: 'form-query',
                            meta: {
                                title: '工作联系单'
                            },
                            component: () => import('@/common/form/form-view/form-view.vue')
                        },
                    ]
                },
                {
                    path: 'plan',
                    name: 'plan',
                    meta: {
                        title: '计划管理'
                    },
                    component: resolve => require(['@/views/plan-manager/index.vue'], resolve),
                    children: [
                        {
                            path: 'progress/:formKey',
                            name: 'progress',
                            meta: {
                                title: '工程进度'
                            },
                            component: () => import('@/components/progress/progressIndex.vue')
                        },
                        {
                            path: 'query/:formKey',
                            name: 'form-query',
                            meta: {
                                title: '材料进场计划'
                            },
                            component: () => import('@/common/form/form-view/form-view.vue')
                        },
                        {
                          path: 'my/:formKey',
                          name: 'form-query',
                          meta: {
                            title: '上报'
                          },
                          component: () => import('@/common/form/form-view/form-view.vue')
                        },
                    ]
                },
                {
                    path: 'form/query/:formKey',
                    name: 'form-query',
                    // meta: {
                    //     title: ''
                    // },
                    component: () => import('@/common/form/form-view/form-view.vue')
                },
                {
                    path: 'environmental',
                    name: 'environmental',
                    meta: {
                        title: '环境监控'
                    },
                    component: resolve => require(['@/components/environmental/environmentalIndex.vue'], resolve)
                },
                {
                    path: 'crane',
                    name: 'crane',
                    meta: {
                        title: '塔机监测'
                    },
                    component: resolve => require(['@/components/crane/craneIndex.vue'], resolve)
                },
                {
                    path: 'SystemDocumentation',
                    meta: {
                        title: '工程文档'
                    },
                    component: resolve => require(['@/components/projectDocuments/SystemDocumentation.vue'], resolve),
                    // component: resolve => require(['@/components/projectDocuments/Test.vue'], resolve),
                    // component: resolve => require(['@/components/projectDocuments/index.vue'], resolve),
                    // children: [
                    //     {
                    //         path: '',
                    //         meta: {
                    //             title: '文档管理'
                    //         },
                    //         component: resolve => require(['@/components/projectDocuments/SystemDocumentation.vue'], resolve)
                    //     },
                    // ]
                },
                {
                    path: 'startRecord',
                    meta: {
                        title: '开工备案'
                    },
                    component: resolve => require(['@/components/projectDocuments/startWorkRecord.vue'], resolve),
                },
                {
                    path: 'dataBase',
                    meta: {
                        title: '资料库'
                    },
                    component: resolve => require(['@/components/projectDocuments/DataBase.vue'], resolve),
                },
                {
                    path: 'check/authorization',
                    name: 'check/authorization',
                    meta: {
                        title: '检查权限'
                    },
                    component: resolve => require(['@/components/checkManage/authorization/authorization.vue'], resolve)
                },
                {
                    path: 'checkManage',
                    component: resolve => require(['@/components/checkManage/checkManageIndex.vue'], resolve),
                    children: [
                        {
                            path: '',
                            meta: {
                                title: '质量检查'
                            },
                            component: resolve => require(['@/components/checkManage/checkIndex.vue'], resolve)
                        },
                        {
                            path: 'checkProblem',
                            name: 'checkProblem',
                            meta: {
                                title: '质量检查'
                            },
                            component: resolve => require(['@/components/checkManage/checkProblem.vue'], resolve)
                        },
                        // {
                        //     path: 'jurisdiction',
                        //     name: 'jurisdiction',
                        //     meta: {
                        //         title: '权限配置'
                        //     },
                        //     component: resolve => require(['@/components/checkManage/Jurisdiction.vue'], resolve)
                        // },
                        {
                          path: 'planning',
                          meta: {
                            title: '质量检查'
                          },
                          component: resolve => require(['@/components/checkManage/Planning.vue'], resolve)
                        },
                        {
                            path: 'checkSet',
                            name: 'checkSet',
                            meta: {
                                title: '质量检查'
                            },
                            component: resolve => require(['@/components/checkManage/checkSet.vue'], resolve)
                        },
                        {
                            path: 'form/query/:formKey',
                            name: 'form-query',
                            meta: {
                                   title: '质量检查'
                            },
                            component: () => import('@/common/form/form-view/form-view.vue')
					    },
                    ]
                },
                {

                    path: 'safetyCheck',
                    component: resolve => require(['@/components/checkManage/safetyManageIndex.vue'], resolve),
                    children: [
                        {
                            path: '',
                            meta: {
                                title: '安全检查'
                            },
                            component: resolve => require(['@/components/checkManage/checkIndex.vue'], resolve)
                        },
                        {
                            path: 'checkProblem',
                            name: 'checkProblem',
                            meta: {
                                title: '安全检查'
                            },
                            component: resolve => require(['@/components/checkManage/checkProblem.vue'], resolve)
                        },
                        {
                            path: 'checkSet',
                            name: 'checkSet',
                            meta: {
                                title: '安全检查'
                            },
                            component: resolve => require(['@/components/checkManage/checkSet.vue'], resolve)
                        },
                    ]
                },
                {
                    path: 'material',
                    component: resolve => require(['@/components/material/PageIndex.vue'], resolve),
                    children: [
                        {
					      path: 'form/query/:formKey',
					      name: 'form-query',
					      meta: {
					         title: '物料验收'
					      },
					      component: () => import('@/common/form/form-view/form-view.vue')
					    },
                    ]
                },
                {
                  path: 'ProcessManagement',
                  component: resolve => require(['@/components/ProcessManagement/index.vue'], resolve),
                  children: [
                    {
                      path: '',
                      meta: {
                        title: '工序管理'
                      },
                      component: resolve => require(['@/components/ProcessManagement/ProcessManagementIndex.vue'], resolve)
                    },
                    {
                      path: 'workingProcedure',
                      meta: {
                        title: '工序管理'
                      },
                      component: resolve => require(['@/components/ProcessManagement/workingProcedure.vue'], resolve)
                    },
                    {
                      path: 'InspectionLot',
                      meta: {
                        title: '工序管理'
                      },
                      component: resolve => require(['@/components/ProcessManagement/InspectionLot.vue'], resolve)
                    },
                    {
                        path: 'planning',
                        meta: {
                        title: '工序管理'
                        },
                        component: resolve => require(['@/components/ProcessManagement/Planning.vue'], resolve)
                    },
                    {
                      path: 'ProcessTask',
                      meta: {
                        title: '工序管理'
                      },
                      component: resolve => require(['@/components/ProcessManagement/ProcessTask.vue'], resolve)
                    },
                    {
                      path: 'Rectification',
                      meta: {
                        title: '工序管理'
                      },
                      component: resolve => require(['@/components/ProcessManagement/Rectification.vue'], resolve)
                    },
                    {
                      path: 'ProcessStatistics',
                      meta: {
                        title: '工序管理'
                      },
                      component: resolve => require(['@/components/ProcessManagement/ProcessStatistics.vue'], resolve)
                    },
                    // {
                    //     path: 'form/query/:formKey',
                    //     name: 'form-query',
                    //     meta: {
                    //        title: '工序管理'
                    //     },
                    //     component: () => import('@/common/form/form-view/form-view.vue')
                    // },
                  ]
                },
                {
                    path: 'measured',
                    component: resolve => require(['@/components/measured/PageIndex.vue'], resolve),
                    children: [
                        {
                            path: '',
                            meta: {
                                title: '实测实量'
                            },
                            component: resolve => require(['@/components/measured/MeasuredIndex.vue'], resolve)
                        },
                        {
                            path: 'areaMeasured',
                            path: 'areaMeasured',
                            meta: {
                                title: '实测实量'
                            },
                            component: resolve => require(['@/components/measured/AreaMeasured.vue'], resolve)
                        },
                        {
                            path: 'checkProblem',
                            path: 'checkProblem',
                            meta: {
                                title: '实测实量'
                            },
                            component: resolve => require(['@/components/measured/MeasuredProblem.vue'], resolve)
                        },
                        // {
                        //   path: 'planning',
                        //   meta: {
                        //     title: '实测实量'
                        //   },
                        //   component: resolve => require(['@/components/measured/Planning.vue'], resolve)
                        // },
                        {
                            path: 'checkSet',
                            name: 'checkSet',
                            meta: {
                                title: '实测实量'
                            },
                            component: resolve => require(['@/components/measured/checkSet.vue'], resolve)
                        },
                        {
					      path: 'form/query/:formKey',
					      name: 'form-query',
					      meta: {
					         title: '实测实量'
					      },
					      component: () => import('@/common/form/form-view/form-view.vue')
					    },

                    ]
                },
                {
                    path: 'cost',
                    component: resolve => require(['@/views/cost/index.vue'], resolve),
                    children: [
                        {
					      path: 'form/query/:formKey',
					      name: 'form-query',
					      meta: {
					         title: '表单查询'
					      },
					      component: () => import('@/common/form/form-view/form-view.vue')
					    },
                    ]
                },
                {
                    path: '*',
                    redirect: '/page',
                },
            ],
        },
        {
            path: '/common',
            component: resolve => require(['@/common/index.vue'], resolve),
            children: [{
                path: 'leaflet',
                meta: {
                    title: '图片预览'
                },
                component: resolve => require(['@/common/leaflet.vue'], resolve)
            }]
        },
        {
            path: '/login',
            meta: {
                title: '智慧工地管理平台'
            },
            component: resolve => require(['@/components/login.vue'], resolve),
        },
        {
            path: '/',
            meta: {
                title: '智慧工地管理平台'
            },
            component: resolve => require(['@/components/login.vue'], resolve),
        },
        {
            path:'/gb-library-select',
            name: 'gb-library-select',
            meta:{
            title: '选择国标库',
            },
            component:resolve => require(['@/components/gb-library/select/index.vue'], resolve)
        },
        {
            path:'/select-areaItem',
            name: 'select-areaItem',
            meta:{
            title: '选择区域检查项',
            },
            component:resolve => require(['@/components/checkManage/select-areaItem/select-areaItem.vue'], resolve)
        },
        {
            path:'/companyLibrary-import',
            name: 'companyLibrary-import',
            meta:{
            title: '企业库导入',
            },
            component:resolve => require(['@/views/companyLibrary-import/index.vue'], resolve)
        },
        {
            path:'/appProjectUser',
            name: 'form-appProjectUser',
            meta:{
            title: '添加项目人员',
            },
            component:resolve => require(['@/views/form-pop-up/appProjectUser.vue'], resolve)
        },
        {
            path:'/fileShare/:businessKey',
            name: 'fileShare',
            meta:{
            title: '文件分享',
            },
            component:resolve => require(['@/views/FileShare.vue'], resolve)
        },
        {
            path: '/app/projDetails',
            name: 'app/projDetails',
            meta: {
                title: '项目详情',
                noToken:true
            },
            component: resolve => require(['@/views/app/ProjectDetails.vue'], resolve)
        },
        {
            path:'/sso',
            name: 'sso',
            meta:{
                title: 'cas单点登录',
            },
            component:resolve => require(['@/views/sso.vue'], resolve)
        },
        {
            path:'/404',
            name: '404',
            meta:{
                title: '页面不存在',
            },
            component:resolve => require(['@/views/404.vue'], resolve)
        },
        {
            path: '*',
            redirect: '/404',
        },
    ]
})
router.beforeEach((to, from, next) => {
    // to and from are both route objects
    if(to.meta.title){
        document.title = to.meta.title;
    }else{
        document.title =titleMap[to.path]
    }
    next()
    util.unmask()

})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js